import React, { Component } from "react";
import "./Testimonials.css";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "./Testimonials.css";
import { Container, Row, Col } from "react-bootstrap";
class Testimonials extends Component {
  state = {
    slides: [
      {
        title: "Xam Idea Science for CBSE Class 10 - 2020 Exam",
        description:
          "This book is amazing, Arrived in 3 days, It is the latest edition for the board exams of 2020, it has NCERT Board 2019 questions solved properly in the extra questions and some exaplers too. I recommend you to buy this book!",
        stars: [{}, {}, {}, {}],
        ISBN: "9789388893299",
        by: 'Deepak Kumar Gupta'
      },
      {
        title: "Xam Idea Social Science for CBSE Class 10 - 2020 Exam ",
        description:
          "Perfect book for cbse 10th class. Font size is awesome wen compared to other books like arihant and all in one. Xam idea is very comfortable for reading. And we can find sample papers. That make students to score more in their examination",
        stars: [{}, {}, {}, {},{}],
        ISBN: "9789388893312",
        by: 'Shalik Subhan Ali'

      },
      {
        title: "Xam Idea English Class 12 for 2019 Exam ",
        description:
          "I would strongly suggest you to go for Exam Idea because it is full of illustrations and important questions. Class 12th is the base for further studies of English and the concepts are presented in a simple language in this book.",
        stars: [{}, {}, {}, {}],
        ISBN: "9789387958449",
        by: 'Satish Kumar'

      },
      {
        title: "Xam Idea Biology for CBSE Class 12- 2020 Exam",
        description:
          "I recommend this book to all those who feel really lazy,hate reading the NCERT biology book, hate biology,don't understand the subject or find it very hard. This book consist of the same content as in the NCERT book but in bullet points which helps us remember and understand each thing very smoothly and easily. It helps you get rid of mugging up. It has a lot of questions at the end of chapter to practice and excel in the particular chapter. Where I failed in biology in my half yearly exams,this book helped me score 90+ in my 12th boards. Xam Idea biology book is my most favorite biology book which made me fall in deep love with bio and so will happen with you too, I assure that.",
        stars: [{}, {}, {}, {},{}],
        ISBN: "9789388893503",
        by: 'Paro'

      },
    ],
  };
  render() {
    return (
      <div>
        <Container className="TESTIMONIALS">
          <h3 className="testHeading headingTesti">TESTIMONIALS</h3>
          <Slider>
            {this.state.slides.map((slide, index) => {
              return (
                <Row id="test" key={index + 1} className="TestimonialsContent">
                  <Col className="testBooks" md={2}>
                    <img src={`https://vkpublications.com/image_resize.php?path=images/titles/CBSE/${slide.ISBN}.jpg&width=250&height=350`} alt = "book" />
                  </Col>
                  <Col className = "testimonialDetail" md={9}>
                    {slide.stars.map((star, index) => {
                      return (
                        <i key={index} className="fas customStars fa-star"></i>
                      );
                    })}
                    <p className = "isbn">ISBN : {slide.ISBN}</p>
                    <p className="description">{slide.description}</p>
                    <p className="description">- {slide.by}</p>
                    <p className = "source"> Platform - Amazon.in </p>
                  </Col>
                </Row>
              );
            })}
          </Slider>
        </Container>
        {/* <Slider>
          {this.state.slides.map((slide, index) => (
            <div key={index}>
              <h2>{slide.title}</h2>
              <div>{slide.description}</div>
            </div>
          ))}
        </Slider> */}
      </div>
    );
  }
}

export default Testimonials;
